import React from "react";
import * as Yup from "yup";

import Form from "@Components/Form";
import {
  MOHR_BRANCH_URL,
  MOHR_TERRITORIES_URL,
  STATE_FETCH_URL,
  DISTRICT_FETCH_URL,
  URLS,
} from "configs/constants";
import { useState } from "react";

const initialValues = {
  branch_name: "",
  territory: "",
  state: "",
  district: "",
  address: "",
  location: "",
  contact_number: "",
  is_headquarter: false,
  active: true,
};

const validationSchema = Yup.object({
  branch_name: Yup.string().required("Branch name is required"),
  territory: Yup.string().required("Territory is required").nullable(),
  state: Yup.string().required("State is required").nullable(),
  district: Yup.string().required("District is required").nullable(),
  address: Yup.string().required("Address is required"),
});

const BranchCreateForm = () => {
  const [disableDistrict, setDisableDistrict] = useState(true);

  const formFields = [
    {
      type: "input",
      name: "branch_name",
      label: "Branch Name",
      required: true,
      gridSize: {
        xs: 12,
        sm: 6,
        md: 4,
        lg: 4,
      },
    },
    {
      type: "reactselect",
      name: "territory",
      label: "Territory",
      required: true,
      proxyUrl: MOHR_TERRITORIES_URL,
      paginated: false,
      gridSize: {
        xs: 12,
        sm: 6,
        md: 4,
        lg: 3,
      },
    },
    {
      type: "reactselect",
      name: "state",
      label: "State",
      required: true,
      proxyUrl: STATE_FETCH_URL,
      getValue: (e) => getStateValues(e, setDisableDistrict),

      paginated: true,
      gridSize: {
        xs: 12,
        sm: 6,
        md: 4,
        lg: 2,
      },
    },
    {
      type: "reactselect",
      name: "district",
      label: "District",
      disabled:disableDistrict,

      required: true,
      proxyUrl: DISTRICT_FETCH_URL,
      paginated: true,
      optionsDependsOn: "state",
      gridSize: {
        xs: 12,
        sm: 6,
        md: 4,
        lg: 2,
      },
    },
    {
      type: "input",
      name: "address",
      label: "Address",
      required: true,
      multiline: true,
      rows: 3,
      gridSize: {
        xs: 12,
        sm: 6,
        md: 4,
        lg: 5,
      },
    },
    {
      type: "input",
      name: "contact_number",
      label: "Contact Numbers(Separated By Comma)",
      gridSize: {
        xs: 12,
        sm: 6,
        md: 4,
        lg: 4,
      },
      multiline: true,
    },
    {
      type: "mapfield",
      mapName: "location",
      label: "Map Geolocation",
      required: true,
      multiline: true,
      rows: 3,
      gridSize: {
        xs: 12,
      },
    },

    {
      type: "switch",
      name: "is_headquarter",
      label: "Headquarter?",
      gridSize: {
        xs: 12,
      },
    },
    {
      type: "switch",
      name: "active",
      label: "Active?",
      gridSize: {
        xs: 12,
      },
    },
  ];
  const getStateValues = (e,setDisableDistrict) => {
    if (!e || e.length === 0) {
      setDisableDistrict(true);
    }
    else {
      setDisableDistrict(false);
    }
    
  };
  const formButtons = ["save", "cancel"];

  return (
    <Form
      initialValues={initialValues}
      validationSchema={validationSchema}
      submitUrl={MOHR_BRANCH_URL}
      listRoute={URLS.MOHR_LIST}
      formFields={formFields}
      formButtons={formButtons}
      formTitle="Branch Setup"
    />
  );
};

export default BranchCreateForm;
